import React from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function PageShell({ children, testid }) {
  return (
    <div data-testid={testid} className="bg-ivory text-charcoal min-h-screen">
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
}
